import React, { useContext, useState } from 'react'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import { EmployeeFormContext } from './EmployeeForm'
import AnDateField from '../../../../components/DateTime/DateField'

const DrivingLicence = () => {
  const { formValues, setFormValues } = useContext(EmployeeFormContext)
  const [hasLicence, setHasLicence] = useState(
    !!formValues?.employee?.personnelInfo?.driving?.licenceNumber
  )
  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title">Driving Licence</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControlLabel
            label="Does the person hold a valid driving licence?"
            control={
              <Checkbox
                checked={hasLicence}
                onChange={(event) => {
                  const checked = event.target.checked
                  setHasLicence(checked)
                  // Non-drivers must have the licence fields cleared, not just
                  // hidden — a recorded licence number is what puts an
                  // employee in scope for driving licence checks
                  if (!checked) {
                    setFormValues((prev) => ({
                      ...prev,
                      employee: {
                        ...prev.employee,
                        personnelInfo: {
                          ...prev.employee?.personnelInfo,
                          driving: {
                            ...prev.employee?.personnelInfo?.driving,
                            licenceNumber: '',
                            licenceExpiry: null,
                            hasC1: false,
                            hasBlueLight: false,
                          },
                        },
                      },
                    }))
                  }
                }}
              />
            }
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {hasLicence && (
            <FormControlLabel
              label="Do they have C1 entitlement?"
              control={
                <Checkbox
                  checked={
                    !!formValues?.employee?.personnelInfo?.driving?.hasC1
                  }
                  onChange={(event) =>
                    setFormValues((prev) => ({
                      ...prev,
                      employee: {
                        ...prev.employee,
                        personnelInfo: {
                          ...prev.employee?.personnelInfo,
                          driving: {
                            ...prev.employee?.personnelInfo?.driving,
                            hasC1: event.target.checked,
                          },
                        },
                      },
                    }))
                  }
                />
              }
            />
          )}
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControlLabel
            label="Permitted to Drive?"
            control={
              <Checkbox
                checked={
                  !!formValues?.employee?.personnelInfo?.driving
                    ?.permissionToDrive
                }
                onChange={(event) => {
                  setFormValues((prev) => ({
                    ...prev,
                    employee: {
                      ...prev.employee,
                      personnelInfo: {
                        ...prev.employee?.personnelInfo,
                        driving: {
                          ...prev.employee?.personnelInfo?.driving,
                          permissionToDrive: event.target.checked,
                        },
                      },
                    },
                  }))
                }}
              />
            }
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {hasLicence && (
            <FormControlLabel
              label="Blue Light Qualified"
              control={
                <Checkbox
                  checked={
                    !!formValues?.employee?.personnelInfo?.driving?.hasBlueLight
                  }
                  onChange={(event) =>
                    setFormValues((prev) => ({
                      ...prev,
                      employee: {
                        ...prev.employee,
                        personnelInfo: {
                          ...prev.employee?.personnelInfo,
                          driving: {
                            ...prev.employee?.personnelInfo?.driving,
                            hasBlueLight: event.target.checked,
                          },
                        },
                      },
                    }))
                  }
                />
              }
            />
          )}
        </Grid>
        {hasLicence && (
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12} lg={7}>
              <TextField
                label="Driving Licence Number"
                value={
                  formValues?.employee?.personnelInfo?.driving?.licenceNumber ??
                  ''
                }
                onChange={(event) =>
                  setFormValues((prev) => ({
                    ...prev,
                    employee: {
                      ...prev.employee,
                      personnelInfo: {
                        ...prev.employee?.personnelInfo,
                        driving: {
                          ...prev.employee?.personnelInfo?.driving,
                          licenceNumber: event.target.value,
                        },
                      },
                    },
                  }))
                }
                fullWidth
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} lg={5}>
              <AnDateField
                date={
                  formValues?.employee?.personnelInfo?.driving?.licenceExpiry
                }
                label="Licence Expiry Date"
                fullWidth
                onChange={(newDate) =>
                  setFormValues((prev) => ({
                    ...prev,
                    employee: {
                      ...prev.employee,
                      personnelInfo: {
                        ...prev.employee?.personnelInfo,
                        driving: {
                          ...prev.employee?.personnelInfo?.driving,
                          licenceExpiry: newDate,
                        },
                      },
                    },
                  }))
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default DrivingLicence
